import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            job: Object,
            content: String,
        }
    }

    dispatch() {
        if(!this.jobValue) {
            return null;
        }

        window.dispatchEvent(new CustomEvent('openJob', {
            detail: {
                job: {
                ...this.jobValue,
                },
                content: this.contentValue,
            },
        }));
    }
}
